export default __webpack_public_path__ + "static/media/Bracers of the Revelations.242c758d.jpg";